import { CLASS_NAMES, EVENTS } from '@bs/constants';

/**
 * A class for the IntroductionCampaign module
 */
export default class IntroductionCampaign {
  /**
   * Constructor function of the IntroductionCampaign class. Must receive one arguments, a DOM
   * node representing the email block.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    /**
     * DOM node that is passed into the constructor
     * @property {object} element DOM node that is passed into the constructor
     */
    this.element = element;

    // Initialize the view
    this.init();
  }

  /**
   * Initializes the view by calling the functions to
   * create DOM references, setup event handlers and
   * then create the event listeners
   * @returns {object} IntroductionCampaign A reference to the current instance of the class
   * @chainable
   */
  init() {
    this.cacheDomReferences().setupHandlers().enable();

    return this;
  }

  /**
   * Cache DOM References
   *
   * Find all necessary DOM elements used in the view and cache them
   * @returns {object} IntroductionCampaign A reference to the current instance of the class
   * @chainable
   */
  cacheDomReferences() {
    return this;
  }

  /**
   * Create event handlers to enable interaction with view
   * @returns {object} Search A reference to the current instance of the class
   * @chainable
   */
  enable() {
    return this;
  }

  /**
   * Bind event handlers with the proper context of `this`.
   * @returns {object} A reference to the current instance of the class
   * @chainable
   */
  setupHandlers() {
    window.addEventListener(EVENTS.SCROLL, this.onScroll.bind(this));
    return this;
  }

  /**
   * Scroll event handler
   */
  onScroll() {
    const { top } = this.element.getBoundingClientRect();
    const inViewport = top + 300 <= window.innerHeight;

    if (inViewport) {
      this.element.classList.add(CLASS_NAMES.IN_VIEWPORT);
    }
  }
}
